const BASE_SELECTOR: string = "[data-scroll]";
const NAV_SELECTOR: string = ".nav__anchor";
const CLOSE_SELECTOR: string = ".off-canvas__close";

export class ScrollUI {

  public constructor(private $base: HTMLElement) {
  }

  public onNavClick(callback) {
    const NAV_ELEMENTS = Array.from(this.$base.querySelectorAll(NAV_SELECTOR));

    NAV_ELEMENTS.forEach((element)  => {
      element.addEventListener('click', (event) => {
        window.setTimeout( () => {
          const close = this.$base.querySelector(CLOSE_SELECTOR) as HTMLElement;
          close.click();
        }, 1000)
        const ID = element.getAttribute('data-href');
        if (!this.isHome()) {
            window.location.href = window.homeUrl + '/#' + ID;
            this.$base.classList.add("is-fixed");
        }
        else {
            callback(ID);
            event.preventDefault();
            return false;
        }
      });
    });
  }

  public isHome() : boolean {
    return document.body.classList.contains('home');
  }

  public getAnchorElement(ID) {
    return document.getElementById(ID) as HTMLElement;
  }


  public smoothScroll (position: number) {
    window.scroll({
      top: position,
      left: 0,
      behavior: 'smooth'
    });
  }

    public getOffset(el: HTMLElement) : number {
        return el.offsetTop;
    }
}

export function createScrollInstances() {
  const $base = document.querySelectorAll(BASE_SELECTOR);
  let uiInstances: ScrollUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new ScrollUI(element));
  }

  return uiInstances;
}
